const { Heading } = require('@chakra-ui/react');

const CompanyInfo = () => {
  return <Heading p="10vh">Company Info</Heading>;
};

export default CompanyInfo;
